export const BREAKPOINTS = ['default', 'sm', 'smp', 'md', 'mdp', 'lg', 'xl'] as const;

// Create a type from the array values
type Breakpoint = (typeof BREAKPOINTS)[number];

const BREAKPOINTS_MAP: Map<Breakpoint, number> = new Map([
  ['sm', 580],
  ['smp', 720],
  ['md', 960],
  ['mdp', 1136],
  ['lg', 1440],
  ['xl', 1600],
]);

export const BREAKPOINTS_MEDIA: Map<Breakpoint, string> = new Map(
  Array.from(BREAKPOINTS_MAP.entries()).map(([key, value]) => [
    key,
    // Intentionally use px as unit instead of px so browser doesn't need CSS to be loaded to evaluate the sizes
    `min-width: ${value}px`,
  ]),
);

export type ImageBreakpointSrcSetSizes = [
  /** The breakpoint query */
  Breakpoint,
  /** The image size */
  number,
][];

export type ImageSrcSetSizes = [
  /** The media query */
  string,
  /** The image size */
  number,
][];
